// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","input":"option-container_input__jB42j","label":"option-container_label__1unSv"};